import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';

class TermsAndName extends Resetter(Validator(React.Component)) {
  state = {
    approveTerms: this.props.approveTerms || false,
    contractorName: this.props.contractorName || '',
    errors: {},
  }

  static VALIDATIONS = {
    contractorName: true,
    approveTerms: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      contractorName: this.state.contractorName,
      approveTerms: this.state.approveTerms,
      tab: 2,
    });
  }

  handleNameChange = (e) => {
    this.setState({ contractorName: e.target.value });
  }

  handleApproveTermsChange = () => {
    this.setState({ approveTerms: !this.state.approveTerms });
  };

  render() {
    const { contractorName, errors } = this.state;
    return (
      <Fragment>
        <CheckBox
          label="Approve Terms *"
          required
          text="I confirm I've read and agree with the payment terms."
          errors={errors.approveTerms} onChange={this.handleApproveTermsChange}
          checked={this.state.approveTerms}
        />
        <SimpleInput
          label="Print Contractor's Name *"
          required
          text={contractorName}
          errors={errors.contractorName}
          onChange={this.handleNameChange}
        />
        <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      </Fragment>
    );
  }
}

TermsAndName.propTypes = {
  errors: PropTypes.shape({
    approveTerms: PropTypes.arrayOf(PropTypes.string),
    contractorName: PropTypes.arrayOf(PropTypes.string),
  }),
};


export default connect(state => ({ errors: state.phase.laborSheets.errors }), {
})(TermsAndName);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLabor/termsAndName.jsx